export default {
  isChromeExtension: process.env.REACT_APP_IS_CHROME_EXTENSION === 'true',
  shouldTestChromeApp: process.env.REACT_APP_STUB_CHROME === 'true',
  appUrl: process.env.REACT_APP_BASE_APP_URL ?? '',
}
